import Divider from "@assets/divider.svg?react";
import type { Route } from "@route-types/Author/+types/Author";
import PageArticleList from "@src/app/components/ArticleList/PageArticleList";
import AuthorCard from "@src/app/components/AuthorCard/AuthorCard";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import SectionContainer from "@src/app/components/SectionContainer";
import {
  parsePayload,
  useRouteResponse,
} from "@src/app/hooks/useRouteResponse";
import type { AuthorPageResponse } from "@src/app/types/response";

import { fetchAuthorPageData } from "./Author.server";

export const loader = fetchAuthorPageData;

export const meta = (args: Route.MetaArgs) => {
  const payload = parsePayload<AuthorPageResponse>(args.loaderData);

  const author = payload.author;

  return createMetaTags({
    title: `${author?.name || ""}作者的文章 - 红蚂蚁`,
    description: `${author?.name || ""}作者文章 - 《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。`,
    canonical: `https://www.redants.sg${author?.urlPath || ""}`,
  });
};

export default function AuthorPage() {
  const res = useRouteResponse("authorPage");
  const author = res.author;

  return (
    <div className="m-auto lg:px-[24px]">
      <SectionContainer showHeader={false}>
        <AuthorCard
          id={author?.id}
          imgSrc={author?.imageUrl}
          authorName={author?.name}
          email={author?.email}
          twitter={author?.twitterHandle}
          designation={author?.designation}
          description={author?.bio_raw}
        />
      </SectionContainer>
      <Divider className="mx-auto my-[16px] max-w-[1200px] px-[12px]" />
      <PageArticleList
        initialData={res.articles || []}
        requestPath={author?.id ? `/author/${author.id}` : ""}
        showHeader={false}
        className="lg:px-[24px]"
      />
    </div>
  );
}
